export const firebaseConfig = {
  apiKey: "AIzaSyAVljzooKMjZTxBbtwEbT2vrh3RLMf_TTo",
  authDomain: "whitepeterson.firebaseapp.com",
  databaseURL: "https://whitepeterson.firebaseio.com",
  projectId: "whitepeterson",
  storageBucket: "whitepeterson.appspot.com",
  messagingSenderId: "168374745632",
  appId: "1:168374745632:web:3e0397009c778bfecfda45",
  measurementId: "G-MTD6YB73Y9"
};
